import React, { Component } from "react";
import { Popconfirm, Table, Divider, Input, Button, Icon, message } from "antd";
import { connect } from "react-redux";
import Highlighter from "react-highlight-words";

import { remove, select as selectRequiriment } from "./../../actions/requirement";
import { select as selectRequirimentType } from "./../../actions/requirement.type";
import ButtonsGroup from "./buttons.group";
import FormRequirement from "./form.requirement";
import { tableSort, tableFooter } from "../../../../components/util";

const REPORT_PARAMS = {
    accao: "lista",
    lista: "requisitos",
    campos: "tipo_requisito:400:Tipo de requisito;designacao:400:Requisito;",
    titulo: "Requisitos",
};
class Requirement extends Component {
    componentDidMount() {
        if (!this.props.isRequirimentLoadded) {
            this.getRequirement();
            this.props.selectRequirimentType({
                accao: "lista",
                lista: "tipos_requisitos",
                pagina: 1,
                resultados_pagina: 0,
            });
        }
    }
    /** get requirement from the server */
    getRequirement = () => {
        this.setState({ isFetching: true });
        this.props
            .selectRequiriment({
                accao: "lista",
                lista: "requisitos",
                pagina: 1,
                resultados_pagina: 0,
                mostra_lista_eliminados: this.state.show_deleted_records,
                ...this.state.filter,
            })
            .then(() => this.setState({ isFetching: false }));
    };
    /** for search results in table */
    getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={(node) => {
                        this.searchInput = node;
                    }}
                    placeholder={`Pesquisar ${dataIndex}`}
                    value={selectedKeys}
                    onChange={(e) => setSelectedKeys(e.target.value ? e.target.value : null)}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: "block" }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Pesquisar
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    limpar
                </Button>
            </div>
        ),
        filterIcon: (filtered) => <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />,
        // onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        // onFilterDropdownVisibleChange: (visible) => {
        //     if (visible) {
        //         setTimeout(() => this.searchInput.select());
        //     }
        // },
        // render: (text) => (
        //     <Highlighter
        //         highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
        //         searchWords={[this.state.searchText]}
        //         autoEscape
        //         textToHighlight={text.toString()}
        //     />
        // ),
    });

    handleSearch = (selectedKeys, confirm) => {
        confirm();
        this.setState({ searchText: selectedKeys });
    };

    handleReset = (clearFilters) => {
        clearFilters();
        this.setState({ searchText: "" });
    };
    /****************************** */

    columns = [
        {
            title: "Tipo de requisito",
            dataIndex: "tipo_requisito",
            width: "30%",
            sorter: (a, b) => tableSort(a.tipo_requisito, b.tipo_requisito),
            sortDirections: ["descend", "ascend"],
            ...this.getColumnSearchProps("tipo_requisito"),
        },
        {
            title: "Requisito",
            dataIndex: "designacao",
            width: "50%",
            sorter: (a, b) => tableSort(a.designacao, b.designacao),
            sortDirections: ["descend", "ascend"],
            ...this.getColumnSearchProps("designacao"),
        },
        {
            title: "Ações",
            dataIndex: "actions",
            width: "20%",
            render: (text, record) => {
                return record._eliminado_ === "t" ? (
                    <>
                        <Button
                            type="link"
                            style={{
                                padding: 0,
                            }}
                            onClick={() => this.handleEdit(record)}
                        >
                            Editar
                        </Button>
                        <Divider type="vertical" />
                        <Popconfirm
                            title="Tens certeza que desejas eliminar?"
                            okText="Ok"
                            cancelText="Não"
                            onConfirm={() => this.delete(record.id_requisito)}
                        >
                            <Button
                                type="link"
                                style={{
                                    padding: 0,
                                    color: "#fa541c",
                                }}
                            >
                                Eliminar
                            </Button>
                        </Popconfirm>
                    </>
                ) : null;
            },
        },
    ];

    state = {
        show_deleted_records: false,
        isVisible: false,
        editRecord: false,
        isFetching: false,
        recordToEdit: {},
        filter: {},
    };

    showModal = () => {
        this.setState({
            isVisible: true,
            editRecord: false,
        });
    };

    hiddeModal = () => {
        this.setState({
            isVisible: false,
        });
    };

    handleEdit = (row) => {
        this.setState({
            isVisible: true,
            editRecord: true,
            recordToEdit: { ...row },
        });
    };

    delete = (id) => {
        this.props
            .remove({
                accao: "eliminar",
                lista: "requisitos",
                chave1: id,
            })
            .then((sucess) => {
                if (sucess) {
                    message.success("Linha eliminada com sucesso");
                    this.getRequirement();
                } else {
                    message.error("Ocorreu um erro");
                }
            });
    };

    showDeletedRecords = (e) => {
        this.setState({ show_deleted_records: e.target.checked }, () => this.getRequirement());
    };

    handleTableChange = (_pagination, filters, sorter) => {
        const obj = {};
        let ordernacao = {};
        if (filters) {
            Object.entries(filters).forEach(([key, val]) => {
                if (val) obj["filtro_" + key] = val;
            });
        }
        if (sorter.columnKey) {
            const order = sorter.order !== "descend" ? "ASC" : "DESC";
            ordernacao = { [`ordenacao_${sorter.columnKey}`]: order };
        }

        this.setState({ ...this.state, currentPage: 1, filter: { ...obj, ...ordernacao } }, () =>
            this.getRequirement()
        );
    };

    render() {
        return (
            <>
                {this.state.isVisible ? (
                    <FormRequirement
                        showDeletedRecords={this.state.show_deleted_records}
                        dataToEdit={this.state.recordToEdit}
                        isEdit={this.state.editRecord}
                        hiddeModal={this.hiddeModal}
                        handleOk={this.handleOk}
                        isVisible={this.state.isVisible}
                    />
                ) : null}
                <ButtonsGroup
                    showDeletedRecords={this.showDeletedRecords.bind(this)}
                    handleOnClick={this.showModal.bind(this)}
                    REPORT_PARAMS={REPORT_PARAMS}
                    filter={this.state.filter}
                />
                <Table
                    rowKey={(record) => record.id_requisito}
                    dataSource={this.props.requirementList}
                    columns={this.columns}
                    size="middle"
                    footer={() => tableFooter(this.props.totalRegisto)}
                    loading={this.state.isFetching}
                    onChange={this.handleTableChange}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        requirementList: Object.values(state.requirement.domain.byId),
        isRequirimentLoadded: state.requirement.app.isFetched,
        isRequirimenTypeLoadded: state.requirementType.app.isFetched,
        totalRegisto: state.requirement.domain.metaData.attributes.resultados,
    };
};

const mapDispatchToProps = {
    selectRequiriment,
    selectRequirimentType,
    remove,
};

export default connect(mapStateToProps, mapDispatchToProps)(Requirement);
